import { isBrowser } from './detection';

export const LOCAL_STORAGE_KEYS = {
  EXPRESS_DESIGNER: 'express_designer',
} as const;

/**
 * A safe wrapper for browser localStorage that checks for window availability.
 *
 * These methods guard against usage in non-browser environments (e.g. during SSR in Next.js),
 * avoiding runtime errors by validating that `window` and `localStorage` exist.
 */
export const LocalStorage = {
  /**
   * Stores a value in localStorage under the specified key.
   *
   * @param key - The localStorage key to set.
   * @param value - The value to store. It will be stringifies.
   */
  setItem(key: string, value: unknown): void {
    if (isBrowser()) {
      window.localStorage.setItem(key, (value as string).toString());
    }
  },

  /**
   * Retrieves a value from localStorage by key.
   *
   * @param key - The localStorage key to retrieve.
   * @returns The stored value as a string, or `null` if not found or not in a browser context.
   */
  getItem(key: string): string | null {
    if (!isBrowser()) return null;

    return window.localStorage.getItem(key);
  },

  /**
   * Removes a key-value pair from localStorage.
   *
   * @param key - The localStorage key to remove.
   */
  removeItem(key: string): void {
    if (isBrowser()) {
      window.localStorage.removeItem(key);
    }
  },
};
